(function () {
    const ignoreClients = ["freo"];
    const toggleClass = "is-closed";

    const handleCardToggle = (elem) => {
        if (elem.classList.contains("o-card__title")) {
            elem.parentElement.classList.toggle(toggleClass);
        }
    };

    document.addEventListener("keyup", (e) => {
        const listenToCodes = ["Enter", "Space"];

        if (listenToCodes.find((code) => code === e.code)) {
            if (e.target instanceof Element) {
                handleCardToggle(e.target);
            }
        }
    });

    window.addEventListener("DOMContentLoaded", () => {
        let isIgnored = false;
        for (const client of ignoreClients) {
            const res = document.querySelectorAll(`.global-brand-${client}`);
            if (res.length) {
                isIgnored = true;
                break;
            }
        }
        const toggleElements = Array.from(
            document.querySelectorAll(".o-card--toggle")
        );

        if (toggleElements["length"]) {
            for (const elem of toggleElements) {
                if (isIgnored) {
                    elem.classList.remove("o-card--toggle");
                    return;
                }

                elem.classList.add(toggleClass);
                elem.querySelector("h2")?.setAttribute("tabindex", "0");
                elem.addEventListener("click", (e) => {
                    if (e.target instanceof Element) {
                        handleCardToggle(e.target);
                    }
                });
            }
        }
    });
})();
